import { render, staticRenderFns } from "./Nanai.vue?vue&type=template&id=1b44d968&scoped=true&"
import script from "./Nanai.vue?vue&type=script&lang=js&"
export * from "./Nanai.vue?vue&type=script&lang=js&"
import style0 from "./Nanai.vue?vue&type=style&index=0&id=1b44d968&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b44d968",
  null
  
)

export default component.exports